var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1023.9 230.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.67,101.19a21.85,21.85,0,0,1-8.79-1.72,19,19,0,0,1-6.81-4.92,22.3,22.3,0,0,1-4.41-7.8,32,32,0,0,1-1.57-10.42,31.73,31.73,0,0,1,1.57-10.39,21.26,21.26,0,0,1,4.41-7.65,18.76,18.76,0,0,1,6.81-4.74,24.35,24.35,0,0,1,17.57,0,18.84,18.84,0,0,1,6.82,4.77A22.1,22.1,0,0,1,379.68,66a31.78,31.78,0,0,1,1.56,10.32,32.28,32.28,0,0,1-1.56,10.42,22.62,22.62,0,0,1-4.41,7.8,19.1,19.1,0,0,1-6.82,4.92,21.83,21.83,0,0,1-8.78,1.72m0-9.26a8.87,8.87,0,0,0,7.72-4.19q2.85-4.2,2.85-11.41t-2.85-11.15a9.45,9.45,0,0,0-15.45,0q-2.83,4-2.84,11.15t2.84,11.41a8.89,8.89,0,0,0,7.73,4.19",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.57 87.48 382.92 81.07 390.72 76.69 390.72 52.78 401.44 52.78 401.44 71.74 412.95 65.39 416.6 71.81 401.44 80.05 401.44 91.27 420.24 91.27 420.24 100.31 390.72 100.31 390.72 85 386.57 87.48",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.73,101.19a21.85,21.85,0,0,1-8.79-1.72,19.1,19.1,0,0,1-6.82-4.92,22.44,22.44,0,0,1-4.4-7.8,32,32,0,0,1-1.57-10.42,31.73,31.73,0,0,1,1.57-10.39,21.39,21.39,0,0,1,4.4-7.65,18.88,18.88,0,0,1,6.82-4.74,24.35,24.35,0,0,1,17.57,0,18.84,18.84,0,0,1,6.82,4.77A22.1,22.1,0,0,1,467.74,66a31.78,31.78,0,0,1,1.56,10.32,32.28,32.28,0,0,1-1.56,10.42,22.62,22.62,0,0,1-4.41,7.8,19.1,19.1,0,0,1-6.82,4.92,21.83,21.83,0,0,1-8.78,1.72m0-9.26a8.87,8.87,0,0,0,7.72-4.19q2.85-4.2,2.85-11.41t-2.85-11.15a9.45,9.45,0,0,0-15.45,0q-2.85,4-2.84,11.15T440,87.74a8.88,8.88,0,0,0,7.73,4.19",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.85,100.31V52.78h11l12.4,23.62,4.66,10.5h.29q-.36-3.8-.83-8.46a86.94,86.94,0,0,1-.48-8.89V52.78H530.1v47.53h-11L506.7,76.62,502,66.27h-.29q.36,3.93.84,8.46a82.72,82.72,0,0,1,.47,8.74v16.84Z",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.27,100.31l14.87-47.53h12.91l14.87,47.53H566.55L563.63,89H549.12l-2.91,11.3Zm17.21-24-1.17,4.37h10.13l-1.09-4.37q-1-3.57-2-7.58c-.63-2.68-1.26-5.25-1.89-7.73h-.3l-1.78,7.76q-.92,4-1.93,7.55",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.83,101.19q-9.26,0-14.14-5.47T582.8,78.3V52.78h10.79V79.39c0,4.67.7,7.92,2.11,9.77a7.23,7.23,0,0,0,6.13,2.77A7.41,7.41,0,0,0,608,89.16c1.46-1.85,2.19-5.1,2.19-9.77V52.78h10.35V78.3q0,12-4.77,17.42t-14,5.47",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.57 100.31 631.57 52.78 642.28 52.78 642.28 72.25 642.58 72.25 656.72 52.78 668.53 52.78 654.17 71.74 671.15 100.31 659.41 100.31 647.83 80.27 642.28 87.56 642.28 100.31 631.57 100.31",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.65,101.19a21.85,21.85,0,0,1-8.79-1.72,19,19,0,0,1-6.81-4.92,22.3,22.3,0,0,1-4.41-7.8,32,32,0,0,1-1.57-10.42,31.73,31.73,0,0,1,1.57-10.39,21.26,21.26,0,0,1,4.41-7.65,18.76,18.76,0,0,1,6.81-4.74,24.35,24.35,0,0,1,17.57,0,18.84,18.84,0,0,1,6.82,4.77A22.1,22.1,0,0,1,715.66,66a31.78,31.78,0,0,1,1.56,10.32,32.28,32.28,0,0,1-1.56,10.42,22.62,22.62,0,0,1-4.41,7.8,19.1,19.1,0,0,1-6.82,4.92,21.83,21.83,0,0,1-8.78,1.72m0-9.26a8.87,8.87,0,0,0,7.72-4.19q2.85-4.2,2.85-11.41t-2.85-11.15a9.45,9.45,0,0,0-15.45,0q-2.85,4-2.84,11.15t2.84,11.41a8.88,8.88,0,0,0,7.73,4.19",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.42,100.31,721.6,52.78h11L735.88,75q.43,3.72,1,7.47c.34,2.5.66,5,.95,7.54h.29c.49-2.52,1-5,1.42-7.54s.94-5,1.42-7.47L746,52.78h9.11L760.23,75c.49,2.43,1,4.89,1.42,7.4s.94,5,1.42,7.61h.3q.5-3.86,1-7.58c.32-2.48.64-5,1-7.43l3.28-22.24h10.28l-8.45,47.53H757l-4.66-21.57c-.39-1.85-.75-3.71-1.06-5.58s-.6-3.68-.84-5.43h-.29c-.29,1.75-.6,3.56-.91,5.43s-.67,3.73-1.06,5.58l-4.45,21.57Z",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "785.45 100.31 785.45 52.78 815.19 52.78 815.19 61.82 796.17 61.82 796.17 71.37 812.35 71.37 812.35 80.34 796.17 80.34 796.17 91.27 815.92 91.27 815.92 100.31 785.45 100.31",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.1,166a26.7,26.7,0,0,1-9.3-1.71,24.19,24.19,0,0,1-8.27-5.14l6.12-7.36a23.07,23.07,0,0,0,5.65,3.57,14.94,14.94,0,0,0,6.09,1.39,8.29,8.29,0,0,0,5-1.24,4,4,0,0,0,1.64-3.36,3.61,3.61,0,0,0-.47-1.89,4.53,4.53,0,0,0-1.38-1.42,12.37,12.37,0,0,0-2.19-1.17l-2.81-1.2L304,143.82a17.81,17.81,0,0,1-3.54-1.89,15.64,15.64,0,0,1-3.06-2.74,12.21,12.21,0,0,1-2.15-3.64,12.87,12.87,0,0,1-.8-4.7,12.55,12.55,0,0,1,1.24-5.51,13.72,13.72,0,0,1,3.49-4.52,17,17,0,0,1,5.36-3,20.37,20.37,0,0,1,6.82-1.09,22.07,22.07,0,0,1,8.2,1.6,20.64,20.64,0,0,1,7.11,4.67l-5.47,6.77a20.64,20.64,0,0,0-4.67-2.8,13.09,13.09,0,0,0-5.17-1,7.66,7.66,0,0,0-4.41,1.13,3.63,3.63,0,0,0-1.64,3.18,3.13,3.13,0,0,0,.54,1.85,5.47,5.47,0,0,0,1.53,1.39,16.94,16.94,0,0,0,2.3,1.17c.88.36,1.82.76,2.84,1.2l6.13,2.48a16.74,16.74,0,0,1,6.89,4.81,12.38,12.38,0,0,1,2.51,8.09,13.45,13.45,0,0,1-4.7,10.31,17.39,17.39,0,0,1-5.65,3.21,22.41,22.41,0,0,1-7.58,1.2",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.38 165.11 345.38 126.62 332.33 126.62 332.33 117.58 369.22 117.58 369.22 126.62 356.17 126.62 356.17 165.11 345.38 165.11",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.39,166q-9.27,0-14.14-5.46t-4.89-17.42V117.58h10.79v26.61q0,7,2.11,9.77a7.26,7.26,0,0,0,6.13,2.77,7.44,7.44,0,0,0,6.19-2.77q2.19-2.78,2.19-9.77V117.58h10.35V143.1q0,12-4.77,17.42t-14,5.46",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.13,165.11V117.58h13.41a32.26,32.26,0,0,1,9.84,1.39,19.66,19.66,0,0,1,7.51,4.26,18.72,18.72,0,0,1,4.81,7.33,29.86,29.86,0,0,1,1.68,10.57,30.5,30.5,0,0,1-1.68,10.64,19.79,19.79,0,0,1-4.74,7.47,19.41,19.41,0,0,1-7.32,4.41,29.09,29.09,0,0,1-9.52,1.46Zm10.71-8.67h2.05a17.81,17.81,0,0,0,5.54-.81,10.11,10.11,0,0,0,4.22-2.58,12.14,12.14,0,0,0,2.74-4.71,23,23,0,0,0,1-7.21,22.38,22.38,0,0,0-1-7.11,11.49,11.49,0,0,0-2.74-4.59,10,10,0,0,0-4.22-2.45,19.88,19.88,0,0,0-5.54-.72h-2.05Z",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.42 165.11 471.42 117.58 501.16 117.58 501.16 126.62 482.13 126.62 482.13 136.17 498.32 136.17 498.32 145.14 482.13 145.14 482.13 156.07 501.89 156.07 501.89 165.11 471.42 165.11",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.36,165.11V117.58h11l12.39,23.62,4.67,10.5h.29q-.36-3.8-.84-8.46t-.47-8.89V117.58h10.2v47.53h-11l-12.4-23.69-4.66-10.35h-.29q.36,3.93.84,8.45a85.68,85.68,0,0,1,.47,8.75v16.84Z",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "569.1 165.11 569.1 126.62 556.05 126.62 556.05 117.58 592.93 117.58 592.93 126.62 579.89 126.62 579.89 165.11 569.1 165.11",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.69,166a22,22,0,0,1-8.79-1.71,19.06,19.06,0,0,1-6.81-4.92,22.48,22.48,0,0,1-4.41-7.8,35.26,35.26,0,0,1,0-20.81,21.26,21.26,0,0,1,4.41-7.65,18.85,18.85,0,0,1,6.81-4.74,24.35,24.35,0,0,1,17.57,0,18.71,18.71,0,0,1,6.82,4.77,22.1,22.1,0,0,1,4.41,7.69,31.78,31.78,0,0,1,1.57,10.32,32.27,32.27,0,0,1-1.57,10.42,22.8,22.8,0,0,1-4.41,7.8,19.1,19.1,0,0,1-6.82,4.92,22,22,0,0,1-8.78,1.71m0-9.25a8.89,8.89,0,0,0,7.73-4.2q2.83-4.18,2.84-11.4c0-4.77-1-8.48-2.84-11.16A9.46,9.46,0,0,0,612,130c-1.89,2.68-2.84,6.39-2.84,11.16s1,8.61,2.84,11.4a8.88,8.88,0,0,0,7.73,4.2M619,115.54l-4.81-5.39,12.46-10.21,5.69,6.93Z",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.46,165.11l-8.82-47.53h11l3.28,22.23c.29,2.48.6,5,1,7.48s.65,5,.94,7.54h.29c.49-2.52,1-5,1.43-7.54s.93-5,1.42-7.48l5.1-22.23h9.11l5.11,22.23c.48,2.44,1,4.9,1.42,7.4s.93,5,1.42,7.62h.29q.51-3.86,1-7.58t1-7.44l3.28-22.23h10.28l-8.46,47.53H681l-4.66-21.58q-.58-2.76-1.06-5.57c-.31-1.87-.59-3.69-.84-5.43h-.29c-.29,1.74-.59,3.56-.91,5.43s-.67,3.73-1.06,5.57l-4.44,21.58Z",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.3,165.11l-8.82-47.53h11l3.28,22.23q.43,3.72,1,7.48c.34,2.5.65,5,.95,7.54H736c.48-2.52,1-5,1.42-7.54s.93-5,1.42-7.48l5.1-22.23H753l5.1,22.23c.48,2.44,1,4.9,1.42,7.4s.93,5,1.42,7.62h.29q.51-3.86,1-7.58t1-7.44l3.28-22.23h10.28l-8.46,47.53H754.84l-4.67-21.58q-.58-2.76-1-5.57c-.32-1.87-.6-3.69-.84-5.43H748c-.3,1.74-.6,3.56-.92,5.43s-.66,3.73-1.05,5.57l-4.45,21.58Z",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.85,166a26.7,26.7,0,0,1-9.3-1.71,24.1,24.1,0,0,1-8.27-5.14l6.12-7.36a22.88,22.88,0,0,0,5.65,3.57,14.91,14.91,0,0,0,6.09,1.39,8.29,8.29,0,0,0,5-1.24,4,4,0,0,0,1.64-3.36,3.71,3.71,0,0,0-.47-1.89,4.46,4.46,0,0,0-1.39-1.42,12.37,12.37,0,0,0-2.19-1.17l-2.8-1.2-6.2-2.63a18,18,0,0,1-3.53-1.89,15.41,15.41,0,0,1-3.07-2.74,12.4,12.4,0,0,1-2.14-3.64,12.87,12.87,0,0,1-.81-4.7,12.69,12.69,0,0,1,1.24-5.51,13.75,13.75,0,0,1,3.5-4.52,16.86,16.86,0,0,1,5.36-3,20.31,20.31,0,0,1,6.81-1.09,22.12,22.12,0,0,1,8.21,1.6,20.69,20.69,0,0,1,7.1,4.67l-5.46,6.77a20.64,20.64,0,0,0-4.67-2.8,13.14,13.14,0,0,0-5.18-1,7.71,7.71,0,0,0-4.41,1.13,3.65,3.65,0,0,0-1.64,3.18,3.14,3.14,0,0,0,.55,1.85,5.47,5.47,0,0,0,1.53,1.39,16.37,16.37,0,0,0,2.3,1.17l2.84,1.2,6.12,2.48a16.61,16.61,0,0,1,6.89,4.81,12.33,12.33,0,0,1,2.52,8.09,13.45,13.45,0,0,1-4.7,10.31,17.39,17.39,0,0,1-5.65,3.21,22.45,22.45,0,0,1-7.58,1.2",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "823.87 165.11 823.87 117.58 853.61 117.58 853.61 126.62 834.59 126.62 834.59 136.17 850.77 136.17 850.77 145.14 834.59 145.14 834.59 156.07 854.34 156.07 854.34 165.11 823.87 165.11",
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 863.82,
    y: 117.58,
    width: 10.72,
    height: 47.53,
    style: {
      fill: "#85bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.59,229.91V182.38H309a32.7,32.7,0,0,1,9.85,1.38,19.84,19.84,0,0,1,7.5,4.27,18.77,18.77,0,0,1,4.82,7.32,30.18,30.18,0,0,1,1.67,10.57,30.81,30.81,0,0,1-1.67,10.65,19.79,19.79,0,0,1-4.74,7.47,19.45,19.45,0,0,1-7.33,4.41,29.29,29.29,0,0,1-9.51,1.46Zm10.72-8.68h2a17.78,17.78,0,0,0,5.54-.8,10.23,10.23,0,0,0,4.23-2.59,12.29,12.29,0,0,0,2.73-4.7,22.7,22.7,0,0,0,1-7.22,22.08,22.08,0,0,0-1-7.1,11.71,11.71,0,0,0-2.73-4.6,10,10,0,0,0-4.23-2.44,19.82,19.82,0,0,0-5.54-.73h-2Z",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.88 229.91 341.88 182.38 371.62 182.38 371.62 191.42 352.6 191.42 352.6 200.97 368.78 200.97 368.78 209.93 352.6 209.93 352.6 220.87 372.35 220.87 372.35 229.91 341.88 229.91",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.33,230.78a26.65,26.65,0,0,1-9.29-1.71,24,24,0,0,1-8.27-5.14l6.12-7.36a22.88,22.88,0,0,0,5.65,3.57,14.85,14.85,0,0,0,6.09,1.38,8.3,8.3,0,0,0,5-1.23,4,4,0,0,0,1.64-3.36,3.68,3.68,0,0,0-.47-1.89,4.46,4.46,0,0,0-1.39-1.42,12.37,12.37,0,0,0-2.19-1.17l-2.8-1.2-6.2-2.63a18.64,18.64,0,0,1-3.54-1.89,15.64,15.64,0,0,1-3.06-2.74,12.42,12.42,0,0,1-2.15-3.64,13.09,13.09,0,0,1-.8-4.7,12.55,12.55,0,0,1,1.24-5.51,13.75,13.75,0,0,1,3.5-4.52,16.86,16.86,0,0,1,5.36-3,20.27,20.27,0,0,1,6.81-1.1,22,22,0,0,1,8.2,1.61,20.76,20.76,0,0,1,7.11,4.66l-5.47,6.78a20.58,20.58,0,0,0-4.66-2.8,13.14,13.14,0,0,0-5.18-1,7.71,7.71,0,0,0-4.41,1.13,3.65,3.65,0,0,0-1.64,3.17,3.08,3.08,0,0,0,.55,1.86,5.34,5.34,0,0,0,1.53,1.39,15.38,15.38,0,0,0,2.3,1.16l2.84,1.21,6.12,2.47a16.7,16.7,0,0,1,6.89,4.82,12.31,12.31,0,0,1,2.52,8.09,13.5,13.5,0,0,1-4.71,10.31,17.34,17.34,0,0,1-5.64,3.21,22.47,22.47,0,0,1-7.59,1.2",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.36,
    y: 182.38,
    width: 10.72,
    height: 47.53,
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.29,230.78a26.16,26.16,0,0,1-9.14-1.57,20.52,20.52,0,0,1-7.4-4.62,21.35,21.35,0,0,1-4.92-7.62,31.65,31.65,0,0,1,0-21.07,23,23,0,0,1,5-7.84,21.51,21.51,0,0,1,7.39-4.88,24.08,24.08,0,0,1,9-1.68,19.38,19.38,0,0,1,8.89,1.9,22.59,22.59,0,0,1,6.05,4.3l-5.61,6.85a19.85,19.85,0,0,0-3.86-2.69,10.69,10.69,0,0,0-5.1-1.1,11.9,11.9,0,0,0-5.07,1.06,11.35,11.35,0,0,0-4,3,13.91,13.91,0,0,0-2.59,4.82,20.85,20.85,0,0,0-.91,6.41q0,7.37,3.31,11.41t10,4a11.22,11.22,0,0,0,2.84-.36,5.82,5.82,0,0,0,2.26-1.09V211.9h-7.87v-8.75H481V225a20.5,20.5,0,0,1-6.56,4.09,24,24,0,0,1-9.12,1.67",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.81,229.91V182.38h11L514.21,206l4.66,10.49h.29q-.36-3.78-.83-8.45a87.13,87.13,0,0,1-.48-8.9V182.38h10.21v47.53h-11l-12.39-23.69L500,195.86h-.29q.36,3.94.84,8.46a85.53,85.53,0,0,1,.47,8.75v16.84Z",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "563.12 229.91 563.12 191.42 550.07 191.42 550.07 182.38 586.96 182.38 586.96 191.42 573.91 191.42 573.91 229.91 563.12 229.91",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "594.39 229.91 594.39 182.38 605.11 182.38 605.11 200.68 621.51 200.68 621.51 182.38 632.3 182.38 632.3 229.91 621.51 229.91 621.51 210.08 605.11 210.08 605.11 229.91 594.39 229.91",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.52,
    y: 182.38,
    width: 10.72,
    height: 47.53,
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.47,229.91V182.38h11L688.87,206l4.66,10.49h.29q-.36-3.78-.84-8.45t-.47-8.9V182.38h10.21v47.53h-11l-12.39-23.69-4.67-10.36h-.29q.36,3.94.84,8.46a85.53,85.53,0,0,1,.47,8.75v16.84Z",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "713.94 229.91 713.94 182.38 724.66 182.38 724.66 201.84 724.95 201.84 739.09 182.38 750.9 182.38 736.54 201.33 753.52 229.91 741.79 229.91 730.2 209.86 724.66 217.15 724.66 229.91 713.94 229.91",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 758.7,
    y: 182.38,
    width: 10.72,
    height: 47.53,
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.64,229.91V182.38h11L804,206l4.67,10.49H809c-.25-2.52-.52-5.34-.84-8.45a87,87,0,0,1-.47-8.9V182.38h10.2v47.53h-11l-12.39-23.69-4.66-10.36h-.29q.36,3.94.83,8.46a82.84,82.84,0,0,1,.48,8.75v16.84Z",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.11,230.78a26.26,26.26,0,0,1-9.15-1.57,20.6,20.6,0,0,1-7.4-4.62,21.48,21.48,0,0,1-4.92-7.62,31.73,31.73,0,0,1,0-21.07,23,23,0,0,1,5-7.84,21.55,21.55,0,0,1,7.4-4.88,24.08,24.08,0,0,1,9-1.68,19.41,19.41,0,0,1,8.89,1.9,22.59,22.59,0,0,1,6.05,4.3l-5.61,6.85a20.16,20.16,0,0,0-3.86-2.69,10.76,10.76,0,0,0-5.11-1.1,11.88,11.88,0,0,0-5.06,1.06,11.35,11.35,0,0,0-4,3,13.74,13.74,0,0,0-2.59,4.82,20.85,20.85,0,0,0-.91,6.41q0,7.37,3.31,11.41t10,4a11.28,11.28,0,0,0,2.84-.36,5.82,5.82,0,0,0,2.26-1.09V211.9h-7.87v-8.75h17.35V225a20.45,20.45,0,0,1-6.57,4.09,23.88,23.88,0,0,1-9.11,1.67",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "890.21 229.91 890.21 182.38 900.92 182.38 900.92 200.68 917.32 200.68 917.32 182.38 928.11 182.38 928.11 229.91 917.32 229.91 917.32 210.08 900.92 210.08 900.92 229.91 890.21 229.91",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.07,230.78q-9.26,0-14.14-5.46t-4.88-17.43V182.38h10.78V209c0,4.66.71,7.92,2.12,9.76a7.22,7.22,0,0,0,6.12,2.77,7.44,7.44,0,0,0,6.2-2.77c1.45-1.84,2.18-5.1,2.18-9.76V182.38h10.36v25.51q0,12-4.78,17.43t-14,5.46",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.81,229.91V182.38h16.26a40.09,40.09,0,0,1,6.89.55,16.21,16.21,0,0,1,5.54,1.93,10.2,10.2,0,0,1,3.71,3.64,10.94,10.94,0,0,1,1.35,5.69,12.22,12.22,0,0,1-.43,3.21,12.91,12.91,0,0,1-1.24,3,11.46,11.46,0,0,1-1.93,2.48,7.09,7.09,0,0,1-2.59,1.61v.29a11.89,11.89,0,0,1,3.35,1.35,10.74,10.74,0,0,1,2.7,2.29,10.6,10.6,0,0,1,1.82,3.25,12.7,12.7,0,0,1,.66,4.26,13,13,0,0,1-1.43,6.27,12.2,12.2,0,0,1-3.93,4.34,18.3,18.3,0,0,1-5.87,2.55,29.66,29.66,0,0,1-7.22.84Zm10.72-28.51h5q3.93,0,5.72-1.53a5.11,5.11,0,0,0,1.79-4.08,4.29,4.29,0,0,0-1.83-3.93,10.57,10.57,0,0,0-5.61-1.17h-5.1Zm0,20.2h6.05q8.82,0,8.82-6.42a4.85,4.85,0,0,0-2.19-4.48q-2.19-1.35-6.63-1.35h-6.05Z",
    style: {
      fill: "#474f5a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.58,
    height: 35.58,
    style: {
      fill: "#f19106"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.72,
    y: 60.3,
    width: 57.9,
    height: 57.9,
    style: {
      fill: "#84bd4b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.06,121.33c-9-9.28-25.69-25.3-24.2-36,4.42-31.83-13.54-54.4-43.67-70.65-16-8.64-36.3-13.09-56-11.68V2.7H64.62V60.3h56.72v57.9H64.62v57.6h57.21v54.44H179s5.61-15.22,10.26-21c5.83-7.24,26-3.61,36.34-5.57,21.26-4,6.24-22.16,6.57-25.41.46-4.49,10.2-5.07,6.56-11.57-1.27-2.28-2.48-2.17-5.39-4.8,14.8-9-1.28-11.16,1.9-21.95,1.28-4.36,19.26-10,10.85-18.61",
    style: {
      fill: "#84bd4b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.34 118.2 64.62 118.2 64.62 175.8 121.83 175.8 121.34 118.2",
    style: {
      fill: "#474f5a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.59 100.31 295.59 52.78 306.31 52.78 306.31 72.25 306.6 72.25 320.74 52.78 332.55 52.78 318.19 71.74 335.18 100.31 323.44 100.31 311.85 80.27 306.31 87.56 306.31 100.31 295.59 100.31",
    style: {
      fill: "#85bd4b"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigLogo);
export default __webpack_public_path__ + "static/media/bigLogo.a5a9f7436d8158dfeb3ae22494fd2189.svg";
export { ForwardRef as ReactComponent };